import React from 'react';
import '../css/industries.css';

// Import industry images
import steelplant from '../assets/industries/steelplant.jpg';
import miningplant from '../assets/industries/miningplant.jpg';
import marineindusties from '../assets/industries/marineindusties.jpg';
import foodindustry from '../assets/industries/foodindustry.jpg';
import constructionindustry from '../assets/industries/constructionindustry.jpg';
import refineries from '../assets/industries/refineries.jpg';

const Industries = () => {
  const industries = [
    {
      title: 'Steel Plants',
      description: 'Heavy-duty valve solutions for steel manufacturing processes, handling extreme temperatures and pressures.',
      image: steelplant,
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
          <path d="M9 9h6v6H9z"/>
          <path d="M9 1v6M15 1v6M9 17v6M15 17v6M1 9h6M17 9h6M1 15h6M17 15h6"/>
        </svg>
      )
    },
    {
      title: 'Mining Plants',
      description: 'Robust valve systems designed for harsh mining environments and abrasive material handling.',
      image: miningplant,
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7v10l10 5 10-5V7L12 2z"/>
          <path d="M12 22V12"/>
          <path d="M2 7l10 5 10-5"/>
          <path d="M7 9.5l5 2.5 5-2.5"/>
        </svg>
      )
    },
    {
      title: 'Marine Applications',
      description: 'Corrosion-resistant valves engineered for marine environments and offshore operations.',
      image: marineindusties,
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 21h18"/>
          <path d="M5 21V7l8-4v18"/>
          <path d="M19 21V11l-6-4"/>
          <path d="M9 9v.01M9 12v.01M9 15v.01M9 18v.01"/>
        </svg>
      )
    },
    {
      title: 'Food Processing Industry',
      description: 'Sanitary valve solutions meeting strict hygiene standards for food and beverage production.',
      image: foodindustry,
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7v10l10 5 10-5V7L12 2z"/>
          <path d="M12 22V12"/>
          <path d="M2 7l10 5 10-5"/>
          <circle cx="12" cy="12" r="3"/>
        </svg>
      )
    },
    {
      title: 'Construction Industry',
      description: 'Reliable valve systems for construction equipment and infrastructure development projects.',
      image: constructionindustry,
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 21h18"/>
          <path d="M5 21V7l8-4v18"/>
          <path d="M19 21V11l-6-4"/>
          <path d="M9 9v.01M9 12v.01M9 15v.01M9 18v.01"/>
        </svg>
      )
    },
    {
      title: 'Refineries',
      description: 'High-performance valves for petroleum refining processes and chemical processing plants.',
      image: refineries,
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7v10l10 5 10-5V7L12 2z"/>
          <path d="M12 22V12"/>
          <path d="M2 7l10 5 10-5"/>
          <path d="M7 9.5l5 2.5 5-2.5"/>
        </svg>
      )
    }
  ];

  return (
    <section className="industries">
      <div className="container">
        <div className="industries-header">
          <span className="industries-label">Our Expertise</span>
          <h2 className="industries-title">Industries We Serve</h2>
          <p className="industries-subtitle">
            Delivering precision valve solutions across diverse industrial sectors with unmatched reliability and performance
          </p>
        </div>

        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div 
              key={index} 
              className="industry-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="industry-image-container">
                <img 
                  src={industry.image} 
                  alt={industry.title}
                  className="industry-image"
                  loading="lazy"
                />
                <div className="industry-overlay">
                  <div className="industry-icon">
                    {industry.icon}
                  </div>
                </div>
              </div>
              <div className="industry-content">
                <h3 className="industry-title">{industry.title}</h3>
                <p className="industry-description">{industry.description}</p>
              </div>
              <div className="industry-line"></div>
            </div>
          ))}
        </div>

        
      </div>
    </section>
  );
};

export default Industries;
